import { Component, OnInit } from '@angular/core';
import { Login } from './login';
import { AppService } from '../app.service';
import { Router } from '@angular/router';

declare var $;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private service:AppService,private router:Router) { }

  login=new Login();
  loader=false;
  errorMsg:any="";

  ngOnInit() {}

  alert(){
    alert('Please wait.We are processing on your request.');
    return false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  chkLogin(){
    this.loader=true; 
    this.service.post('/login',{"mobile":this.login.mobile,"password":this.login.password}).subscribe(data => {
        if(data[0].error=='0')
        { 
            localStorage.setItem('currentUser', JSON.stringify(data[0]));
            this.router.navigateByUrl("/statement");
            $('#login-signup').modal('toggle');
        }else{
          this.errorMsg=data[0].msg;
        }
        this.loader=false;
      },
      error =>{
        this.errorMsg=error.errorDesc;
        this.loader=false;
      }
    );
  }
}
